import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { getAuthUserId } from '../../../../data/auth/authSelectors'
import { usePatchAIDraftMutation } from '../messagesApi'

export const useExpireAIDraft = () => {
  const [patchAIDraft] = usePatchAIDraftMutation()
  const userId = useSelector(getAuthUserId)
  return useCallback(
    (draftId: string) => patchAIDraft({ providerId: userId, draftId: draftId, status: 'expired' }),
    [patchAIDraft, userId],
  )
}
